export const PASS_API = {
  GET_AVAILABLE_PASSES: "/LandingPasses/available",
  GET_ACTIVE_PASS: "/StudentPasses/active",
  GET_AVAILABLE_PASSES_ERROR: "Get available Dotore passes error",
  GET_ACTIVE_PASS_ERROR: "Get active Dotore pass error",
};

export const ISSUED_PASS_STATUS_CODES = {
  IN_USE: "IN_USE",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
};

export const PASS_BANNER_STATES = {
  LOADING: "LOADING",
  ACTIVE: "ACTIVE",
  NO_PASS: "NO_PASS",
  UNAVAILABLE: "UNAVAILABLE",
};

export const PASS_EXPIRING_SOON_DAYS = 7;

export const PASS_PROMO_STATES = {
  BEFORE_ACTIVATED: "BEFORE_ACTIVATED",
  ACTIVE: "ACTIVE",
};

export const PASS_PROMO_DATE_FORMATS = {
  BADGE_MONTH: "MMM",
  BADGE_DAY: "DD",
  MONTH_NUMBER: "M",
  LONG_MONTH_DAY: "MMMM DD",
  SHORT_MONTH_DAY: "MMM DD",
};

export const PASS_PROMO_MONTH_LABEL_PATTERNS = {
  vi: "Th{{month}}",
  ko: "{{month}}월",
};

export const PASS_PROMO_OFFER_END_DATE = "2026-10-31T23:59:59";
